import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEye, FiBattery, FiShield, FiHeart } = FiIcons;

const FeaturesSection = () => {
  const features = [
    {
      icon: FiEye,
      title: "Sensory-Safe by Default",
      description: "Low-motion options, high-contrast themes, dyslexia-friendly fonts—built in, not bolted on."
    },
    {
      icon: FiBattery,
      title: "Energy-Aware & Flexible",
      description: "Adapts to your energy level, not your schedule. Because some days you're on fire, others you're just surviving."
    },
    {
      icon: FiShield,
      title: "No Shame, Just Structure",
      description: "Encouraging tone that celebrates small wins and validates struggles. Your brain isn't broken—it's feature-rich."
    },
    {
      icon: FiHeart,
      title: "Built By & For Neurodivergent Creators",
      description: "Not a generic PM tool adapted for neurodivergence. Designed from the ground up for AuDHD brains."
    }
  ];

  return (
    <section className="features-section">
      <div className="container mx-auto px-6 py-20">
        <motion.div 
          className="section-header text-center"
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">
            Your brain isn't broken; it's feature-rich and deserves 
            tools built for how you actually think
          </h2>
        </motion.div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              className="feature-card"
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="feature-icon">
                <SafeIcon icon={feature.icon} />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;